import React from 'react';
import { Link } from 'react-router-dom'
import MdArrowBack from 'react-icons/lib/md/arrow-back'
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import Checkbox from 'material-ui/Checkbox';
import {Row,Col, PanelGroup , Panel} from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';
import { Route, withRouter } from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import MdDelete from 'react-icons/lib/md/delete'

import MdFileIcon from 'react-icons/lib/md/attach-file'
import MdToggleIcon from 'react-icons/lib/md/arrow-drop-down-circle'
import _ from 'lodash';
import * as actions from '../../../Actions/index.js';
import { connect } from 'react-redux';
import Header from '../../../Components/Modules/Includes/Header'

class AudioVisual extends React.Component{
	constructor(props) {
	    super(props);
	    this.state = {
	      job: _.cloneDeep(this.props.job),
	    };
	}
	getDescOfWorks(job,manualtype) {
		// let sowItems = job.manuals[manualtype]['sowItems'];

		let items = job.manuals[manualtype]['sowItems'];
		let sowItems = _.filter(items, (item) => {
			return item.ItemType === "Prebuild"
		})


	    if( !sowItems || !sowItems.length ) {
	      return (
	        <li>
	          No data found.
	        </li>
	      )
	    }

	    return _.map(sowItems, (item) => {
	      return (
	      	<li key={`sow-${item.ItemID}`}>
			    <Checkbox checked={item.is_enabled} label={item.ItemName}/> 
			</li>
	      );
	    });
	}
	//get attachments 
	getAttachments(job,manualtype) {
	    let attachments = job.manuals[manualtype]['attachments'];

	    if( !attachments || !attachments.length ) {
	      return (
	        <li>
	          No attachments found.
	        </li>
	      )
	    }

	    return _.map(attachments, (item) => {
	      return (
	        <li key={`attachment-${item.FileName}`}>
	          <Checkbox checked={item.is_enabled} label={item.FileName}/>
	        </li>
	      );
	    });
	}
	// get parts
	getListOfParts(job, manualtype) {
	    let parts = job.manuals[manualtype]['parts'];
	    if( !parts || !parts.length ) {
	      return (
	        <li>
	          No parts found.
	        </li>
	      )
	    }

	    return _.map(parts, (item, key) => {
	    	let parntName=<div>
			    {item.has_attachment ?
			    <span className="attach-icon"><MdFileIcon color="#3c763d" />{item.ItemName}</span>:
			    <span className="attach-icon"><MdFileIcon color="#e94731" />{item.ItemName}</span>
			}
					</div>;
					let items_key = _.map(item.attachment_key, (i, key) => {
						// console.log(item.StockItemID+key.toString());
							return <Checkbox checked={i.is_enabled} label={i.file_name}
							/>
					});
	      return (
	        <li key={`part-${item.StockItemID}`}>
						{/* <Checkbox checked={item.is_enabled} label={parntName}/> */}
						<Panel key={`${item.StockItemID}`} eventKey={`template-group-${parntName}`} >
							<Panel.Heading>
								<Checkbox checked={item.is_enabled} 
									label={item.is_enabled ? <span>All selected</span>: <span>All not selected</span>}
									/>
									{parntName}
								<Panel.Title className="inline-title" toggle>View All<MdToggleIcon color="#3c763d"/> </Panel.Title>
								{/* <Panel.Title toggle>{parntName} </Panel.Title> */}
							</Panel.Heading>
							<Panel.Body collapsible >
								<div className="dashboard-table-data">
									<table width="100%">
										<tbody>
											{items_key}
										</tbody>
									</table>
								</div>
							</Panel.Body>
						</Panel>
	        </li>
	      );
	    });
	}
	getJobDescription(job,manualtype) {
		let sowJobDesc = job.manuals[manualtype]['jobdescription'];
	    if( !sowJobDesc || !sowJobDesc.length ) {
	      return (
	        <li>
	          No Job Description found.
	        </li>
	      )
	    }

	    return _.map(sowJobDesc, (item) => {
	    	let HtmlData = item.textHtml	    	
		    return (
				<ul className="job-description-data-set">
					<li className="job-description-list" key={`sowJobDesc-${item.type}`}>
						<Checkbox checked={item.is_enabled}/>
						<div className="job-description-content" dangerouslySetInnerHTML={{__html: HtmlData}}>
							
						</div>	
					</li>
				</ul>

		    );
	    });
	}
	getCostCenterDesc(job,manualtype){

			let sowCostDesc = job.manuals[manualtype]['ctdescription'];
			sowCostDesc = _.groupBy(sowCostDesc,'costDescName');
		    if( !sowCostDesc || _.isEmpty(sowCostDesc) == true ) {
		      return (
		        <li>
		          No Cost Center Description found.
		        </li>
		      )
		    }

		    return _.map(sowCostDesc, (items, value) => {

		    	let isCostNameEnable = true;
		    	let costDescNameId;
		    	let ctdescs = _.map(items, (item) => {
			    	// ankit code
			    	let HtmlData = item.textHtml
			    	if(item.is_enabled_costName === false ){
			    		isCostNameEnable = false;
			    	}
			    	costDescNameId = item.costDescNo;
				    return (
						<ul className="job-description-data-set margl-40">
							<li className="job-description-list" key={`sowJobDesc-${item.costDescNo}`}>
								<Checkbox checked={item.is_enabled}/>
								<div className="job-description-content" dangerouslySetInnerHTML={{__html: HtmlData}}>
									
								</div>	
							</li>
						</ul>

				    );
			    });
			    return (
			    	<ul className="job-description-data-set parent-ul">
			    		<li class="job-heading" key={`sowJobDesc-${value}`}>
			    			<Checkbox checked={isCostNameEnable}/>
			    			<div className="job-description-content">
			    				{value}
			    			</div>	
			    		</li>
			    		{ctdescs}
			    	</ul>
			    );
		    });
	}
	render(){
		let urlstring = window.location;
	    let getid =urlstring.toString().split('/');
	    let jobid='',manualtype='';
	    if(getid[getid.length-2]){
	      jobid=getid[getid.length-2];
	      manualtype=getid[getid.length-1];
	    }
	    let alljobs= this.props.alljobs;
		var job;
		if(alljobs!==null){
			job=_.filter(alljobs, { 'simpro_id': parseInt(jobid)});
			job=job[0];
		}else{
			return null
		}
	    var compId,companyname;
		let companyjobs= this.props.companyjobs;
		if(companyjobs!==null){
	    	let jobOfCompany= _.filter(companyjobs, { 'job_id': jobid});
	    	if(jobOfCompany.length!=0){
	    		compId=jobOfCompany[0].company_id;
	    		let companies=this.props.companies;
				companyname =_.filter(companies, { '_id': compId})[0].name;
	    		
	    	}
	    }
	    let descOfWorks = this.getDescOfWorks(job,manualtype);
	    let attachments = this.getAttachments(job,manualtype);
	    let listOfParts = this.getListOfParts(job,manualtype);
	    let jobDesc = this.getJobDescription(job,manualtype);
	    let costCenterDesc = this.getCostCenterDesc(job,manualtype);
			let instal_type=job.manuals[manualtype].installation_type;
			
			// var listItems = job.manuals[manualtype].partsAttachmentOrder.map((item, i) => {
			// 	return (
			// 		<li 
			// 			data-id={i}
			// 			key={i}
			// 			className="parts-drag">:: {item}</li>
			// 	)
			//  });

			//  var attachmentItems = job.manuals[manualtype].attachmentOrder.map((item, i) => {
			// 	return (
			// 		<li 
			// 			data-id={i}
			// 			key={i}
			// 			className="attach-drag">:: {item}</li>
			// 	)
			//  });
		return(<div>
					<Header />
					<div className="dashboard-page">
						<div className="right-content-dashboard active-dashboard">
							<div className="audio-visual-content">
								<div className="top-heading">
									<div className="back-button-heading">
										<h2><Link to={`/admin-job/${jobid}`}><MdArrowBack /></Link> <span>{companyname}</span> </h2>
									</div>
									<div className="right-job-id">
										<label>
											<Link to={`#`}>
												JOB#{jobid}-{manualtype}
											</Link>
										</label>
									</div>
								</div>
								<div className="audio-visual-list">
									<h3>Installation</h3>
									<ul>
										<li>
											<RadioButtonGroup name="shipSpeed" defaultSelected={instal_type?instal_type:null} disabled={true}>
										      <RadioButton
										        value='self'
										        label={`System installed by ${companyname}.`}
										      />
										      <RadioButton
										        value="third-party"
										        label="Existing system installed previously by third party."
										      />
										    </RadioButtonGroup>  
										</li>
									</ul>
								</div>
								<div className="clearfix"></div>
								<div className="audio-visual-list">
									<h3>Scope Of Works</h3>
									<ul>
										<div className="wrap-white-back">
											<h3>Pre-builds</h3>
											{ descOfWorks }
											<h3>Job Description</h3>
											{ jobDesc }
											<h3>Cost Centres</h3>
											{ costCenterDesc }
										</div>
									</ul>
								</div>
								<div className="clearfix"></div>
								<div className="audio-visual-list">
									<h3>Attachments</h3>
									<ul>
										{/* <li>
											<ul >
												{attachmentItems}
											</ul>
										</li> */}
										{ attachments }
									</ul>
								</div>
								<div className="clearfix"></div>
								<div className="audio-visual-list margb20px">
									<h3>Stock parts</h3>
									<ul>
										{/* <li>
											<ul >
												{listItems}
											</ul>
										</li> */}
										{listOfParts}
									</ul>
								</div>
								<div className="clearfix"></div>
							</div>
						</div>
					</div>
			   </div>
			)
	}
}



const mapStateToProps= (state,props)=> {
    return {
      companydetails: state.login.companydetail,
      subsusers: state.login.subsuser,
      subscriptions: state.login.subscriptions,
      alljobs: state.login.alljobs,
      companyjobs: state.login.companyjobs,
      templates: state.templates,
      companies: state.login.company,
    };
}
AudioVisual = withRouter(connect(
  mapStateToProps,
  actions
)(AudioVisual));

export default AudioVisual;



// WEBPACK FOOTER //
// ./src/Components/Pages/Admin/AdminAudioVisual.js